export default {
  banners: [
    {
      imgUrl: require('../../assets/images/jobs/job-banner.jpg'),
      title: '発見・選考・採用',
      description: '',
      component: ''
    }
  ],
  jobs: [
    {
      title: 'C/C++開発エンジニア',
      address: '上海（中国）',
      description: `
      給与: 20K-30K / 経験:3-5年 / 学歴:学士以上 / 雇用形態:フルタイム<br/>
      要件：<br/>
      組み込みソフトウェア開発経験。<br/>
      高度なCプログラミングおよびデバッグ能力。<br/>
      RTOS経験があると望ましい。<br/>
      Linux内部構造、IPC、マルチスレッドに関する知識。<br/>
      オープンソースパッケージの利用経験。<br/>
      対応OS：Linux / Android。リアルタイムマルチスレッド設計・開発の実務経験。<br/>
      ツール：ホスト/ターゲットツールチェーンでの開発・デバッグ経験。<br/>
      積極的な姿勢と良好なコミュニケーション能力。
      `
    },
    {
      icon: require('../../assets/images/jobs/job-icon-3.png'),
      title: 'ジュニアCソフトウェアエンジニア',
      address: '成都（中国）',
      description: `
      給与: 6K-8K / 成都 / 経験:1-3年 / 学歴:学士以上 / 雇用形態:フルタイム<br/>
      職務内容：<br/>
      Unix系プラットフォームでのC開発（AIX/Linux）、シェルやデータベースの知見が求められます。<br/>
      要件：2年以上の関連実務経験、学歴証明書の提出が可能であること。
      `
    },
    {
      title: '自然言語処理エンジニア（NLP）',
      address: '成都（中国）',
      description: `
      給与: 10K-20K / 成都 / 経験:3-5年 / 学歴:不問 / 雇用形態:フルタイム<br/>
      職務内容：<br/>
      ・NLPの研究と最先端技術の適用。<br/>
      ・非構造化テキストの特徴抽出、クラスタリング、類似度計算、意味解析など。<br/>
      ・要件に応じた迅速なソリューション提案とプロトタイプ構築。<br/>
      要件：NLP理論・手法に精通し、研究またはプロジェクト経験があること。JavaやLinux環境に強く、データ構造・アルゴリズムの理解があること。チームで協働できるコミュニケーション力。
      `
    },
    {
      title: 'C言語講師',
      address: '成都（中国）',
      description: `
      給与: 3K-4K / 経験:1-3年 / 学歴:専門学校以上 / 雇用形態:パートタイム<br/>
      要件：C言語に精通し、実務プロジェクト経験が豊富であること。
      `
    },
    {
      title: '上級インスタントメッセージング（IM）エンジニア',
      address: '成都（中国）',
      description: `
      給与: 15K-30K / 経験:5-10年 / 学歴:不問 / 雇用形態:フルタイム<br/>
      職務：IMシステムのアーキテクチャ設計・開発・最適化、モバイル/PCクライアントとの統合、コアモジュール実装、メッセージング/プッシュ関連サーバ機能の開発。Javaバックエンド業務含む。<br/>
      要件：Javaでの豊富な開発経験（5年以上）、IO・マルチスレッド・分散システムの理解、TCP/IPやソケットプログラミングの実務経験、クラウド技術への理解、優れたコミュニケーション力。
      `
    },
    {
      title: 'HTML5開発者',
      address: '成都（中国）',
      description: `
      給与: 10K-15K / 経験:3-5年 / 学歴:専門学校以上 / 雇用形態:フルタイム<br/>
      職務：モバイル向けクライアント開発、各種JSフレームワークやHTML5特性を活かしたインタラクション実装、チームビルド、基盤サービス設計・最適化。<br/>
      要件：HTML5、JavaScript、CSS3、jQuery等の実務経験、クロスブラウザ対応知見、ハイブリッドアプリ開発の理解があると尚可。
      `
    },
    {
      title: 'ICTプリセールスエンジニア',
      address: '成都（中国）',
      description: `
      給与: 2K-4K / 経験:1-3年 / 学歴:専門学校以上 / 雇用形態:フルタイム<br/>
      職務：技術提案書作成、入札資料準備、顧客対応、営業との連携による技術折衝・デモ実施、要件収集と調整、パートナーとの技術交流支援。
      `
    },
    {
      title: 'iOS開発エンジニア',
      address: '成都（中国）',
      description: `
      給与: 8K-15K / 経験:3-5年 / 学歴:学士以上 / 雇用形態:フルタイム<br/>
      職務：iOSアプリの設計・実装・品質保証、プラットフォーム技術研究と改善提案。<br/>
      要件：Objective-CまたはSwift、CocoaTouch、Xcodeの実務経験、IMやソケット開発経験があると望ましい。
      `
    },
    {
      title: 'Java開発リーダー',
      address: '成都（中国）',
      description: `
      給与: 12K-16K / 経験:3-5年 / 学歴:学士以上 / 雇用形態:フルタイム<br/>
      職務：6-8名のチーム管理、DB設計、オブジェクト指向設計、設計ドキュメントに基づく開発、テスト支援。<br/>
      要件：Java/J2EE技術に精通し、中大型プロジェクトの実務経験があること。
      `
    },
    {
      title: 'PHPエンジニア',
      address: '成都（中国）',
      description: `
      給与: 8K-13K / 経験:3-5年 / 学歴:専門学校以上 / 雇用形態:フルタイム<br/>
      職務：ECプロジェクトの機能設計・開発・単体テスト・ドキュメント作成。<br/>
      要件：PHPによる大規模Webアプリ開発経験、MySQLやキャッシュ最適化の知見。
      `
    },
    {
      title: '.NET中級・上級ソフトウェアエンジニア',
      address: '成都（中国）',
      description: `
      給与: 10K-15K / 経験:5-10年 / 学歴:学士以上 / 雇用形態:フルタイム<br/>
      職務：ソフトウェア設計・開発・テスト・保守。<br/>
      要件：.NET関連技術、Web技術、SQL Server等の経験。<br/>
      `
    },
    {
      title: 'プロジェクトマネージャー',
      address: '成都（中国）',
      description: `
      給与: 10K-18K / 経験:3-5年 / 学歴:学士以上 / 雇用形態:フルタイム<br/>
      職務：プロジェクトの調査・開発・実施・ライフサイクル管理、顧客折衝、要件管理、進捗とリスク管理。<br/>
      要件：プロジェクト管理経験（2年以上）と技術的背景。
      `
    },
    {
      title: 'Oracleエンジニア',
      address: '成都（中国）',
      description: `
      給与: 5000-7000元/月 / 経験:不問 / 学歴:学士<br/>
      業務内容：ストアドプロシージャやトリガーの作成、Unix環境でのOracle操作、データのインポート/エクスポート、シェルスクリプトの使用。<br/>
      要件：基本的なPL/SQL知識と英語の読み書き能力。
      `
    },
    {
      title: 'ネットワークセキュリティ開発マネージャー',
      address: '成都（中国）',
      description: `
      給与: 13K-26K / 経験:5-10年 / 学歴:不問 / 雇用形態:フルタイム<br/>
      職務：ソフトウェアプロジェクトの設計・開発、システム最適化、モバイル/IoTセキュリティ対応、製品開発支援。<br/>
      要件：Java開発経験4年以上、データベース設計・最適化の知識、LinuxやPythonのスキル。
      `
    },
    {
      title: 'Pythonエンジニア',
      address: '成都（中国）',
      description: `
      給与: 8K-15K / 経験:1-3年 / 学歴:専門学校以上 / 雇用形態:フルタイム<br/>
      職務：Djangoベースのクラウド製品の設計・開発、先端技術の研究と導入。<br/>
      要件：Pythonに精通し、Django等のフレームワーク経験があること。
      `
    },
    {
      title: '大データソフトウェアエンジニア',
      address: '成都（中国）',
      description: `
      給与: 8K-10K / 経験:1-3年 / 学歴:学士以上 / 雇用形態:フルタイム<br/>
      職務：HDFS/MR/HBase/Hive/Spark等のビッグデータ技術を用いた開発。<br/>
      要件：JavaとSQLの堅牢なスキル、ビッグデータツールの利用経験。
      `
    },
    {
      title: 'UIデザイナー',
      address: '成都（中国）',
      description: `
      給与: 7K-10K / 経験:1-3年 / 学歴:専門学校以上 / 雇用形態:フルタイム<br/>
      職務：製品UIの設計・制作、プロモーション素材の作成、開発チームとの協働。<br/>
      要件：Photoshop等ツールの熟練、クリエイティブな発想と実務経験。
      `
    },
    {
      title: 'シニアネットワーク開発エンジニア',
      address: '成都（中国）',
      description: `
      給与: 10K-15K / 経験:3-5年 / 学歴:不問 / 雇用形態:フルタイム<br/>
      職務：企業向けネットワークアプリの開発・保守。<br/>
      要件：Java/J2EE、Spring、RESTfulサービス、分散システムの経験。英語読解力があると望ましい。
      `
    }
  ]
}
